import React, { Component } from 'react'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {Button, Form} from 'react-bootstrap'
import '../css/display.scss'

export default class Question extends Component {
    state={
        link:'',
        value: ''
    }
    componentDidMount(){
        this.state.value = window.location.href
    }
    onChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }
    render() {
        return (
            <div>
       
                         <Form.Group>
    <Form.Label>Question</Form.Label>
    <Form.Control onChange={this.onChange} name="question" placeholder="type your question here" />
    <Form.Text className="text-muted">
      Don't show any mercy XD
    </Form.Text>
  </Form.Group>
  <Button onClick={()=>this.props.addQues(this.state.question)} >Submit</Button>

         
  {this.props.isadmin? 

<div className="admin">
                    <CopyToClipboard text={this.state.value}
                              onCopy={() => this.setState({copied: true})}>
                              <Button variant="link">{this.state.copied?'Copied':'Copy link'}</Button>
                            </CopyToClipboard>
                     
                    </div>
                    :''}


            </div>
        )
    }
}
